function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import dotProp from 'dot-prop';
import { useState } from 'react';
var LOCAL_STORAGE_VALUE_KEY = 'v';
var LOCAL_STORAGE_MIGRATED_KEY = 'mx';
export var StickyValueManager = /*#__PURE__*/function () {
  function StickyValueManager(store, storeName, keyPath, defaultValue) {
    _classCallCheck(this, StickyValueManager);
    this.store = store;
    this.storeName = storeName;
    this.keyPath = keyPath;
    this.defaultValue = defaultValue;
  }
  return _createClass(StickyValueManager, [{
    key: "container",
    get: function get() {
      try {
        var _this$store$getItem;
        return JSON.parse((_this$store$getItem = this.store.getItem(this.storeName)) !== null && _this$store$getItem !== void 0 ? _this$store$getItem : '{}');
      } catch (_unused) {
        return Object.create(null);
      }
    },
    set: function set(value) {
      try {
        this.store.setItem(this.storeName, JSON.stringify(value));
      } catch (err) {
        var error = err instanceof Error ? err : new Error("Unknown error. ".concat(err));
        console.warn("Unable to persist sticky container for ".concat(this.storeName, ". ").concat(error.message));
      }
    }
  }, {
    key: "get",
    value: function get(migrationHydrator) {
      var container = this.container;
      var valuePath = "".concat(this.keyPath, ".").concat(LOCAL_STORAGE_VALUE_KEY);
      var migrated = dotProp.get(container, "".concat(this.keyPath, ".").concat(LOCAL_STORAGE_MIGRATED_KEY), false);
      var value;
      if (migrationHydrator && !migrated) {
        value = migrationHydrator();
        if (value !== undefined) {
          this.setValue(LOCAL_STORAGE_VALUE_KEY, value);
          this.setValue(LOCAL_STORAGE_MIGRATED_KEY, true);
        }
      } else {
        value = dotProp.get(container, valuePath);
        if (value === undefined && this.defaultValue !== undefined) {
          value = this.defaultValue;
          this.setValue(LOCAL_STORAGE_VALUE_KEY, this.defaultValue);
        }
      }
      return value;
    }
  }, {
    key: "set",
    value: function set(value) {
      this.setValue(LOCAL_STORAGE_VALUE_KEY, value);
    }
  }, {
    key: "setValue",
    value: function setValue(key, value) {
      var container = this.container;
      if (Array.isArray(value)) {
        value.sort(Intl.Collator().compare);
      }
      var isUndefined = value === undefined;
      var isEmptyArray = !isUndefined && Array.isArray(value) && !value.length;
      if (isUndefined || isEmptyArray) {
        dotProp["delete"](container, "".concat(this.keyPath, ".").concat(key));
      } else {
        dotProp.set(container, "".concat(this.keyPath, ".").concat(key), value);
      }
      this.container = container;
    }
  }]);
}();
export var useStickyValue = function useStickyValue(store, storeName, keyPath, defaultValue) {
  var _useState = useState(function () {
      return new StickyValueManager(store, storeName, keyPath, defaultValue);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    manager = _useState2[0];
  // state change trigger for consumer
  var _useState3 = useState(function () {
      return manager.get();
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    setPreviousValue = _useState4[1];
  return [function (migrationHydrator) {
    return manager.get(migrationHydrator);
  }, function (value) {
    manager.set(value);
    setPreviousValue(value);
  }];
};